"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.questions.required': '*',
    'onboarding.questions.placeholder.text': 'Enter your answer...',
    'onboarding.questions.placeholder.textarea': 'Enter your detailed answer...',
    'onboarding.questions.placeholder.number': 'Enter a number...',
    'onboarding.questions.placeholder.select': '-- Select an option --',
    'onboarding.questions.empty': 'No questions available for this step.',
};
